import { useState } from "react";
import 'react-phone-input-2/lib/style.css'

export default function Statistic(props: any): JSX.Element {
  const { pagination } = props
  const [loading, setLoading] = useState(false);

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
      <div id="total" style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ fontWeight: 800 }}>Total:</div>
        <div>{pagination?.total || 0}</div>
      </div>
      <div id="sentCount" style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ fontWeight: 800 }}>Sent:</div>
        <div>{pagination?.stats?.sentCount || 0}</div>
      </div>
      <div id="finishedCount" style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ fontWeight: 800 }}>Finished:</div>
        <div>{pagination?.stats?.finishedCount || 0}</div>
      </div>
    </div>
  )
}
